import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";
import datetimeHelper from "../../helper/datetime-helper";

export const GET_LIST_OUTBOUND_CALL = "GET_LIST_OUTBOUND_CALL";
export const GET_LIST_OUTBOUND_CALL_ERROR = "GET_LIST_OUTBOUND_CALL_ERROR";
export const GET_LIST_OUTBOUND_CALL_SUCCESS = "GET_LIST_OUTBOUND_CALL_SUCCESS";

export const GET_LIST_AGENT_OUTBOUND_CALL = "GET_LIST_AGENT_OUTBOUND_CALL";
export const GET_LIST_AGENT_OUTBOUND_CALL_ERROR =
  "GET_LIST_AGENT_OUTBOUND_CALL_ERROR";
export const GET_LIST_AGENT_OUTBOUND_CALL_SUCCESS =
  "GET_LIST_AGENT_OUTBOUND_CALL_SUCCESS";

export const COUNT_NUMBER_OUTBOUND_CALL = "COUNT_NUMBER_OUTBOUND_CALL";
export const COUNT_NUMBER_OUTBOUND_CALL_ERROR =
  "COUNT_NUMBER_OUTBOUND_CALL_ERROR";
export const COUNT_NUMBER_OUTBOUND_CALL_SUCCESS =
  "COUNT_NUMBER_OUTBOUND_CALL_SUCCESS";

export const MAKE_OUTBOUND_CALL = "MAKE_OUTBOUND_CALL";
export const MAKE_OUTBOUND_CALL_SUCCESS = "MAKE_OUTBOUND_CALL_SUCCESS";
export const MAKE_OUTBOUND_CALL_ERROR = "MAKE_OUTBOUND_CALL_ERROR";

export const ADD_NOTE_OUTBOUND_CALL = "ADD_NOTE_OUTBOUND_CALL";
export const ADD_NOTE_OUTBOUND_CALL_SUCCESS = "ADD_NOTE_OUTBOUND_CALL_SUCCESS";
export const ADD_NOTE_OUTBOUND_CALL_ERROR = "ADD_NOTE_OUTBOUND_CALL_ERROR";

/**
 * Reducer
 */

const initialState = {
  outBound: [],
  outBoundsAgent: [],
  error: false,
  count: 0,
  excel: [],
};

export const outBoundReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_OUTBOUND_CALL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_OUTBOUND_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        outBound: action.payload,
      };
    case GET_LIST_OUTBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    case GET_LIST_AGENT_OUTBOUND_CALL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_AGENT_OUTBOUND_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        outBound: action.payload,
      };
    case GET_LIST_AGENT_OUTBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_NUMBER_OUTBOUND_CALL:
      return {
        ...state,
      };
    case COUNT_NUMBER_OUTBOUND_CALL_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_NUMBER_OUTBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //make
    case MAKE_OUTBOUND_CALL:
      return {
        ...state,
      };
    case MAKE_OUTBOUND_CALL_SUCCESS:
      return {
        ...state,
        makeOutboundCall: action.payload,
      };
    case MAKE_OUTBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add note
    case ADD_NOTE_OUTBOUND_CALL:
      return {
        ...state,
      };
    case ADD_NOTE_OUTBOUND_CALL_SUCCESS:
      return {
        ...state,
        outBound: action.payload,
      };
    case ADD_NOTE_OUTBOUND_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getOutboundCall = (order, limit, skip, where, query = {}) => ({
  type: GET_LIST_OUTBOUND_CALL,
  data: {
    order,
    limit,
    skip,
    where,
    query,
  },
});

export const getOutboundCallAgent = (
  agentGroupId,
  order,
  limit,
  skip,
  where
) => ({
  type: GET_LIST_AGENT_OUTBOUND_CALL,
  data: {
    agentGroupId,
    order,
    limit,
    skip,
    where,
  },
});

export const countOutBoundCall = (where) => ({
  type: COUNT_NUMBER_OUTBOUND_CALL,
  data: {
    where,
  },
});

export const makeOutboundCall = (extensionId, dialMode, from, to) => ({
  type: MAKE_OUTBOUND_CALL,
  data: {
    extensionId,
    dialMode,
    from,
    to,
  },
});

export const addNoteOutboundCall = (id, note) => ({
  type: ADD_NOTE_OUTBOUND_CALL,
  data: {
    id,
    note,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOutboundCall,
      countOutBoundCall,
      makeOutboundCall,
      addNoteOutboundCall,
      getOutboundCallAgent,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getOutboundCallApi = (order, limit, skip, where, query) => {
  return apiCaller.getLogs(
    "/cloud-pbx/outbound-call",
    { order, limit, skip, ...where },
    query
  );
};

const getOutboundCallAgentApi = (
  agentGroupId,
  order,
  limit,
  skip,
  where,
  query
) => {
  return apiCaller.getLogs(
    `/cloud-pbx/outbound-call?agentGroupId=${agentGroupId}`,
    { order, limit, skip, ...where, query }
  );
};

const countOutBoundCallApi = (where) => {
  return apiCaller.getData("/cloud-pbx/outbound-call/count", { ...where });
};

const makeOutboundCallApi = (extensionId, dialMode, from, to) => {
  return apiCaller.post("/cloud-pbx/outbound-call", {
    extensionId,
    dialMode,
    from,
    to,
  });
};

const addNoteOutboundCallApi = (id, note) => {
  return apiCaller.put(`/mini-crm/interactive-log?${id}`, { note });
};

/**
 * sagas
 */

export const getOutboundCallFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_OUTBOUND_CALL);
    try {
      const res = yield call(
        getOutboundCallApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.query
      );
      const data = res.data.sort(function (a, b) {
        return (
          new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime()
        );
      });
      data.forEach((item) => {
        item.createdAt = datetimeHelper.toFormat(
          item.createdAt,
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      yield put({ type: GET_LIST_OUTBOUND_CALL_SUCCESS, payload: { ...data } });
    } catch (error) {
      yield put({ type: GET_LIST_OUTBOUND_CALL_ERROR, error });
    }
  }
};

export const getOutboundCallAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_AGENT_OUTBOUND_CALL);
    try {
      const res = yield call(
        getOutboundCallAgentApi,
        action.data.agentGroupId,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_AGENT_OUTBOUND_CALL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_AGENT_OUTBOUND_CALL_ERROR, error });
    }
  }
};

export const countOutBoundCallFlow = function* () {
  while (true) {
    const action = yield take(COUNT_NUMBER_OUTBOUND_CALL);
    try {
      const res = yield call(countOutBoundCallApi, action.data.where);
      yield put({
        type: COUNT_NUMBER_OUTBOUND_CALL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_NUMBER_OUTBOUND_CALL_ERROR, error });
    }
  }
};

export const makeOutboundCallApiFlow = function* () {
  while (true) {
    const action = yield take(MAKE_OUTBOUND_CALL);
    try {
      const res = yield call(
        makeOutboundCallApi,
        action.data.extensionId,
        action.data.dialMode,
        action.data.from,
        action.data.to
      );
      yield put({ type: MAKE_OUTBOUND_CALL_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: MAKE_OUTBOUND_CALL_ERROR, error });
    }
  }
};

export const addNoteOutboundCallApiFlow = function* () {
  while (true) {
    const action = yield take(ADD_NOTE_OUTBOUND_CALL);
    try {
      const res = yield call(
        addNoteOutboundCallApi,
        action.data.id,
        action.data.note
      );
      yield put({
        type: ADD_NOTE_OUTBOUND_CALL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: ADD_NOTE_OUTBOUND_CALL_ERROR, error });
    }
  }
};

export const exportOutbound = async (where) => {
  return await apiCaller.getLogs("/cloud-pbx/outbound-call?query=export", {
    ...where,
  });
};
